import IconNotAcid from "../../../../assets/svg/icon-not-acid.svg";
import IconNotFire from "../../../../assets/svg/icon-not-fire.svg";
import IconComment from "../../../../assets/svg/icon-comment.svg";

export const CORNSTARCH_ITEMS = [
  {
    type: "title",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.cornstarch.title",
  },
  {
    type: "icon",
    translatable: true,
    icon: IconNotAcid,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.cornstarch.notAcid",
  },
  {
    type: "icon",
    translatable: true,
    icon: IconNotFire,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.cornstarch.notHeat",
  },
  {
    type: "icon",
    translatable: true,
    icon: IconComment,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.cornstarch.instruction",
  },
];

export const MCT_OIL_ITEMS = [
  {
    type: "text",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.mctOil",
  },
];

export const MCT_POWDER_ITEMS = [
  {
    type: "text",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.mctPowder",
  },
];

export const TRIHEPTANOIN_ITEMS = [
  {
    type: "text",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.triheptanoin1",
  },
  {
    type: "text",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.triheptanoin2",
  },
  {
    type: "text",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.triheptanoin3",
  },
  {
    type: "text",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.triheptanoin4",
  },
  {
    type: "text",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.triheptanoin5",
  },
];

export const FOOD_DRINK_ITEMS = [
  {
    type: "multi-text",
    translatable: true,
    title:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.beverages.title",
    description: [
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.beverages.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.condiments.title",
    description: [
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.condiments.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.cookingIngredients.title",
    description: [
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.cookingIngredients.description",
    ],
  },
  {
    type: "multi-text",
    translatable: true,
    title:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.quickSnacks.title",
    description: [
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.foodDrink.quickSnacks.description",
    ],
  },
];

export const GLYCOSADE_ITEMS = [
  {
    type: "title",
    translatable: true,
    description:
      "contentText.dietDiary.addMeal.frequentlyForgottenItems.glycosade.title",
  },
];
